import "../School/Schools.css";

export const InvoiceCards = ({ stats }) => {
    const totalInvoices = stats?.total || null;
    const totalPaidInvoices = stats?.paid || null;
    const totalIssueInvoices = stats?.issued || null;

    const statsNew = [
        {
            label: "Total Invoices",
            value: totalInvoices,
            icon: "fa-graduation-cap",
            colorClass: "schools-stat-card-purple",
            iconClass: "schools-stat-icon-blue", // Blue icon bg in purple card
        },
        {
            label: "Paid Invoices",
            value: totalPaidInvoices,
            icon: "fa-user",
            colorClass: "schools-stat-card-green",
            iconClass: "schools-stat-icon-blue",
        },
        {
            label: "Unpaid Invoices",
            value: totalIssueInvoices,
            icon: "fa-flag",
            colorClass: "schools-stat-card-orange",
            iconClass: "schools-stat-icon-blue",
        },
       
    ];

    return (
        <div className="row mb-4">
            {statsNew.map((stat, index) => (
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 mb-3" key={index}>
                    <div className={`schools-stat-card ${stat.colorClass}`}>
                        <div>
                            <p className="schools-stat-label mb-0">{stat.label}: </p>
                        </div>
                        <div className="schools-stat-content">
                            
                            <p className="schools-stat-value">{stat.value}</p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};
